import React, { useState, useRef } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import { Button } from "reactstrap";
import MyLoader from "./util/loader";
import Api from "./api/api";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";

const AddBanner = () => {
  const history = useHistory();
  const [link, setLink] = useState("");
  const [mainShot, setMainShot] = useState(null);
  const [mainShotUrl, setMainShotUrl] = useState(null);
  const [loader, setLoader] = useState(false);
  const addMainShot = useRef(null);

  const saveBanner = () => {
    if (mainShot == null) {
      showToast("error", "Please fill complete form!");
      return;
    }
    setLoader(true);
    Api.addSlide(
      mainShot,
      (response) => {
        setLoader(false);
        console.log(JSON.stringify(response));
        if (response.status === "success") {
          showToast("success", "Banner added!");
          setLink("");
          setMainShot(null);
          setMainShotUrl(null);
          history.goBack();
        } else {
          showToast("error", "Failed!");
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>Add Banner</div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 15,
        }}
      >
        <img
          src={mainShotUrl}
          style={{
            width: 300,
            height: 150,
            marginBottom: 10,
            marginTop: 20,
            objectFit: "conver",
          }}
        />
        <Button
          style={{ marginTop: 0, fontSize: 16 }}
          className="btn-block"
          onClick={() => {
            addMainShot.current.click();
          }}
        >
          Choose Banner Photo
        </Button>
        <input
          type="file"
          style={{ display: "none" }}
          ref={addMainShot}
          onChange={(event) => {
            setMainShot(event.target.files[0]);
            setMainShotUrl(URL.createObjectURL(event.target.files[0]));
          }}
        />
        <Button
          style={{ marginTop: 20, width: 300, fontSize: 16 }}
          className="btn-block btn-dark"
          onClick={() => {
            saveBanner();
          }}
        >
          Add Banner
        </Button>
        {/* <Form className="form" style={{ width: 500, marginTop: 20 }}>
                    <FormGroup>
                        <Input
                            type='text'
                            placeholder='Banner Link (https://www.google.com)'
                            value={link}
                            onChange={(event) => {
                                setLink(event.target.value)
                            }} />
                    </FormGroup>
                    <Button
                        style={{ marginTop: 20 }}
                        className='btn-block btn-dark'
                        onClick={() => {
                            saveBanner()
                        }}>
                        Add Banner
                    </Button>
                </Form> */}
      </div>
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default AddBanner;
